const state = {
	//加入单位
	companyStep: {
		step: '',
		companyName: '',
		company_id: '',
		type: '',
	},
	//一些公共信息
	commonData: {
		noticeCount: 0,
		noticeinfo: [],
		userinfo: {},
	},
	//待处理数
	countWaitToHeadle: {},
	//单位人员列表缓存
	companyUserList : [],
	//地区数据缓存
	addressList : {},
};

export default state


// WEBPACK FOOTER //
// ./src/store/state.js